export const mocks_console = `[RESTRICTED ACCESS GRANTED]
Project Manuscript 2.0//Codification//Unification//Data-set-00.00.01
Version Alpha 00.01
[CLEARANCE LEVEL: JUPITER 1]
Mythic Protocol Decentralized Universal Meta Feed

[DD/MM/YY 00:00:00] Meta Update
>CharlieCharlie-Upload//Clearance=Jupiter//JupiterID
>Mythic Protocol Repository//Confirmed//Entry uploaded//M-0010
>Mythic Protocol Repository//Confirmed//Casefile uploaded//M-0010-0001
   >>Protocol Timeline Appended//Year=1346//KnownEvent="European Bubonic Plague"
      >>Corollary: Mythic=True, Dossier=False, Riftworld=False, ProtocolSite=False
      >>MythicCorrelation=M-0010 - REQUISITE CLEARANCE LEVEL: JUPITER 1
>DUM-NetworkLoad: 115/kb 01.03/sec

[DD/MM/YY 00:00:00] Unconfirmed Entry Submitted
>NovemberCharlie-Upload//Clearance=PapaAlpha//ProfileID####
>Mythic Protocol Repository//Unconfirmed//Entry submission//UC-1001
   >>ProtocolValidation=Pending
   >>CCRequirementsMet=Pending
>DUM-NetworkLoad: 1152/kb 01.03/sec

[DD/MM/YY 00:00:00] Event Report
>GammaEcho//Type=SeismicActivity//Scale=M5.8//Loc=57.401°N 33.376°W
   >>MythicAnomaly=False, ProtocolResponse=False, CallistoDeployment=False
   >>RiftwatchAlert=False, LimaContingency=True, DeltaContingency=False
        >>LimaContingency//Transport//Warhorse-0118 Diverted
>DUM-NetworkLoad: 10/kb 00.08/sec`;
